'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jurisdictions_constants = require('../jurisdictions.constants.js');
var getAmlStatus = require('@gig/magic-sdk/dist/adapter/users/getAmlStatus');

function getGracePeriodDaysLeft(periods) {
  const DAY = 24 * 60 * 60 * 1e3;
  const earliestDate = periods.reduce((lowest, { endDate }) => {
    const endTime = new Date(endDate + "Z").getTime();
    if (!lowest) {
      return endTime;
    }
    return endTime < lowest ? endTime : lowest;
  }, null);
  return earliestDate ? Math.max(0, Math.ceil((earliestDate - Date.now()) / DAY)) : 0;
}
function isKYCRequestedByAML(status) {
  const statuses = [
    getAmlStatus.AmlStatus.PENDING,
    getAmlStatus.AmlStatus.PROCESSING,
    getAmlStatus.AmlStatus.REJECTED
  ];
  return statuses.includes(status.SOWD) || statuses.includes(status.SOWQ) || statuses.includes(status.SOF);
}
function shouldDisplayLinkToWithdraw(jurisdiction, daysLeft) {
  if (daysLeft > 0) {
    return false;
  }
  return jurisdiction === jurisdictions_constants.Jurisdiction.UKGC || jurisdiction === jurisdictions_constants.Jurisdiction.SGA;
}

exports.getGracePeriodDaysLeft = getGracePeriodDaysLeft;
exports.isKYCRequestedByAML = isKYCRequestedByAML;
exports.shouldDisplayLinkToWithdraw = shouldDisplayLinkToWithdraw;
